import { Text, useToast, VStack } from '@chakra-ui/react';
import React from 'react';
import { useDeleteOfficerAssessment } from '../../../../../services/api/generated/client';
import { localise, templateReplace } from '../../../../../services/lang/lang';
import { ConfirmationModal } from '../../../ConfirmationModal/ConfirmationModal';
const DeleteOfficerAssessmentModal = ({ officerAssessment, remoteSubmission, onClose, onDeleted, }) => {
    const toast = useToast();
    const { mutate, isPending, isError, error } = useDeleteOfficerAssessment();
    const onDelete = () => {
        mutate({ officerAssessmentId: officerAssessment.id }, {
            onSuccess: () => {
                onDeleted();
                toast({
                    title: templateReplace(localise('DELETED'), {
                        noun: localise('OFFICER_ASSESSMENT'),
                    }),
                    status: 'success',
                });
            },
        });
    };
    return (React.createElement(ConfirmationModal, { isOpen: true, onClose: onClose, onConfirm: onDelete, title: localise('DELETE_OFFICER_ASSESSMENT'), isLoading: isPending, isError: isError, confirmText: localise('DELETE_CHALLENGE'), error: error },
        React.createElement(VStack, { align: "stretch" },
            React.createElement(Text, { "data-testid": "delete_officer_assessment_modal__text", variant: "md-600-rg-3" }, templateReplace(localise('DELETE_OFFICER_ASSESSMENT_CONFIRM_QUESTION'), {
                reference: remoteSubmission.reference,
            })),
            React.createElement(Text, { "data-testid": "delete_officer_assessment_modal__sub_text", variant: "md-600-rg-3" }, localise('ENTER_CONFIRMATION_TEXT')))));
};
export default DeleteOfficerAssessmentModal;
